import React from 'react';
import { BookOpen, Droplets, Sparkles, ShieldAlert } from 'lucide-react';
export function BonusesSection() {
  return <section className="py-20 bg-[#060919] relative border-t border-white/5" data-id="element-1">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-4">
            Todo lo que recibes <span className="text-yellow-400" data-id="element-5">HOY</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-6">
            Un arsenal completo para recuperar tu soberanía espiritual y blindar
            tu energía para siempre.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-7">
          {/* Main Product */}
          <div className="lg:col-span-12 bg-gradient-to-r from-[#1a1f3a] to-[#0a0e27] border border-yellow-500/30 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 shadow-[0_0_40px_rgba(212,175,55,0.1)]" data-id="element-8">
            <div className="w-full md:w-1/3 flex justify-center" data-id="element-9">
              <div className="w-24 h-24 bg-yellow-500/20 rounded-full flex items-center justify-center border border-yellow-500/40 shadow-[0_0_30px_rgba(212,175,55,0.3)]" data-id="element-10">
                <BookOpen className="w-12 h-12 text-yellow-400" data-id="element-11" />
              </div>
            </div>
            <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-12">
              <div className="inline-block bg-yellow-500/20 text-yellow-400 px-3 py-1 rounded-full text-sm font-bold mb-4" data-id="element-13">
                PROGRAMA PRINCIPAL
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-14">
                La Guía Maestra de Liberación y Protección Energética
              </h3>
              <p className="text-gray-300 text-lg leading-relaxed" data-id="element-15">
                El manual paso a paso con el Método de Tríada Relámpago.
                Instrucciones claras, precisas y sin relleno para limpiar tu
                campo áurico, cortar lazos tóxicos y sellar tu energía en solo
                72 horas.
              </p>
            </div>
          </div>

          {/* Bonus 1 */}
          <div className="lg:col-span-4 bg-[#1a1f3a]/60 border border-white/10 rounded-3xl p-8 hover:border-yellow-500/30 transition-all hover:-translate-y-1" data-id="element-16">
            <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center mb-6" data-id="element-17">
              <Droplets className="w-6 h-6 text-blue-400" data-id="element-18" />
            </div>
            <div className="text-blue-400 font-bold text-sm mb-2" data-id="element-19">
              BONO 1 (GRATIS)
            </div>
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-20">
              Guía Sagrada de Baños y Despojos
            </h3>
            <p className="text-gray-400" data-id="element-21">
              El recetario exacto con ingredientes que tienes en casa (sal,
              hierbas comunes) para limpiezas profundas de cuerpo y hogar.
              Elimina la energía estancada de tus espacios.
            </p>
          </div>

          {/* Bonus 2 */}
          <div className="lg:col-span-4 bg-[#1a1f3a]/60 border border-white/10 rounded-3xl p-8 hover:border-yellow-500/30 transition-all hover:-translate-y-1" data-id="element-22">
            <div className="w-12 h-12 bg-purple-500/20 rounded-xl flex items-center justify-center mb-6" data-id="element-23">
              <Sparkles className="w-6 h-6 text-purple-400" data-id="element-24" />
            </div>
            <div className="text-purple-400 font-bold text-sm mb-2" data-id="element-25">
              BONO 2 (GRATIS)
            </div>
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-26">
              Manifiesta tu Realidad en 7 Días
            </h3>
            <p className="text-gray-400" data-id="element-27">
              Una vez libre de cargas, tu poder de atracción se multiplica.
              Activa tu magnetismo personal para atraer abundancia, paz y
              oportunidades que antes estaban bloqueadas.
            </p>
          </div>

          {/* Bonus 3 */}
          <div className="lg:col-span-4 bg-gradient-to-br from-[#1a1f3a] to-yellow-900/20 border border-yellow-500/40 rounded-3xl p-8 hover:border-yellow-400 transition-all hover:-translate-y-1 relative overflow-hidden" data-id="element-28">
            <div className="absolute top-0 right-0 bg-yellow-500 text-slate-900 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-29">
              EXCLUSIVO
            </div>
            <div className="w-12 h-12 bg-yellow-500/20 rounded-xl flex items-center justify-center mb-6" data-id="element-30">
              <ShieldAlert className="w-6 h-6 text-yellow-400" data-id="element-31" />
            </div>
            <div className="text-yellow-400 font-bold text-sm mb-2" data-id="element-32">
              BONO 3 (GRATIS)
            </div>
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-33">
              Protocolo de Emergencia: Escudo 60s
            </h3>
            <p className="text-gray-300" data-id="element-34">
              La técnica mental y física para bloquear ataques en tiempo real.
              Úsala cuando estés frente a alguien tóxico, en ambientes pesados o
              cuando sientas un ataque repentino.
            </p>
          </div>
        </div>
      </div>
    </section>;
}